import { render, staticRenderFns } from "./baicset.vue?vue&type=template&id=c2f1c308&scoped=true"
import script from "./baicset.vue?vue&type=script&lang=js"
export * from "./baicset.vue?vue&type=script&lang=js"
import style0 from "./baicset.vue?vue&type=style&index=0&id=c2f1c308&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f1c308",
  null
  
)

export default component.exports